import React, { useEffect, useRef, useState } from "react";
import Layout from "../../../../components/admin/Layout";
import Helmet from "react-helmet";
import Table from "../../../../components/ui/Table";
import usePaginate from "../../../../hooks/api/usePaginate";
import apiRequest from "../../../../utils/admin/apiRequest";
import useModal from "../../../../hooks/ui/useModal";
import Pagination from "../../../../components/ui/Pagination";
import { FaEdit, FaEye, FaPlus, FaTrashAlt } from "react-icons/fa";
import Modal from "../../../../components/ui/utils/Modal";
import Button from "../../../../components/ui/utils/Button";
import useFormInput from "../../../../hooks/form/useFormInput";
import { useSelector } from "react-redux";

import InputField from "../../../../components/ui/form/InputField";
import ProductImport from "../../../../components/admin/vendor/import/ProductImport";
import ProductDelete from "../../../../components/admin/vendor/import/ProductDelete";
import ProductEdit from "../../../../components/admin/vendor/import/ProductEdit";
import { getFileUrl } from "../../../../utils/helper";
import StatusToggle from "../../../../components/ui/StatusToggle";

const ImportCatgeory = () => {
    const {
        currentPage,
        data,
        error,
        fetchData,
        limit,
        loading,
        setPage,
        setSorting,
        sort,
        totalItems,
        totalPages,
        setFilters,
    } = usePaginate({
        apiMethod: apiRequest.getAdminProducts,
        dataKey: "products",
    });





    const { isOpen, openModal, closeModal, actionType } = useModal();
    const handleSort = (field) => {
        const order =
            sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
        setSorting({ sortField: field, sortOrder: order });
    };



    const searchInitialValues = { code: "" };
    const { values, handleChange, setValues } = useFormInput(searchInitialValues);
    const debounceRef = useRef(null);
    useEffect(() => {
        if (values.code !== undefined) {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            debounceRef.current = setTimeout(() => {
                const filters = {};
                filters.vendorId = { $ne: null };
                if (values.code) {
                    filters.code = { $regex: values.code, $options: "i" };
                }
                setFilters(filters);
            }, 500);
            return () => clearTimeout(debounceRef.current);
        }
    }, [values.code]);




    const BRAND_NAME = useSelector(
        (state) => state.globalState?.siteSetting?.site_settings?.site_name
    );
    
    const [activeStatus , setActiveStatus] = useState(false);
    const handleToggle = (newStatus) => {
        console.log("Updated Status:", newStatus);
        setActiveStatus(newStatus)
    };

    return (
        <Layout>
            <Helmet>
                <title>Admin - {BRAND_NAME ?? ''}</title>
            </Helmet>

            <div className="p-4 bg-white rounded">
                <div className="flex items-center gap-1 py-2">
                    <Button
                        onClick={() => openModal({ type: "add" })}
                        variant="primary"
                        isLoading={false}
                    >
                        <div className="flex items-center justify-center gap-3">
                            <FaPlus />
                            <p>Import Product Category</p>
                        </div>
                    </Button>



                </div>
                <div className="grid grid-cols-1 sm:grid-cols-[1fr_100px] gap-2 my-2">
                    <InputField
                        name="code"
                        placeholder="e.g. Summer25"
                        value={values.code}
                        onChange={handleChange}
                    />
                    <button
                        className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
                        onClick={() => setValues(searchInitialValues)}
                    >
                        Clear
                    </button>
                </div>

                <Table
                    headers={[
                        { label: "Product Name", key: "name", sorting: true },
                        { label: "Image", key: "image", sorting: true },
                        { label: "Serial No", key: "itemNo", sorting: true },
                        { label: "Main Category", key: "mainCategory", sorting: true },
                        { label: "Category", key: "itemCategory", sorting: true },
                        { label: "Veg / Non Veg", key: "veg/nonveg", sorting: true },
                        { label: "Vendor Price", key: "vendorPrice", sorting: true },
                        { label: "Customer Price", key: "finalPrice", sorting: true },
                        { label: "GST (%)", key: "gstAmount", sorting: true },
                        { label: "Description", key: "Description", sorting: true },
                        { label: "Quantity", key: "quantity", sorting: true },
                        { label: "Status", key: "status", sorting: true },
                        { label: "Created At", key: "createdAt", sorting: true },
                        { label: "Action", key: "action", sorting: false },
                    ]}
                    loading={loading}
                    handleSort={handleSort}
                    sort={sort}
                    error={error}
                    cols={12}
                    renderRow={
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data?.map((product) => (
                                <tr
                                    key={product._id}
                                    className="transition-colors hover:bg-gray-50"
                                >
                                    <td className="px-3 py-3">
                                        <span className="font-semibold text-gray-800">
                                            {product.name || "-"}
                                        </span>
                                    </td>
                                      <td className="px-3 py-3">
                                                        <div className="w-16 h-16 overflow-hidden">
                                                          <img
                                                            src={getFileUrl(product?.image)}
                                                            alt={product?.name}
                                                            className="object-contain w-full h-full border border-gray-300 rounded"
                                                          />
                                                        </div>
                                                      </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.itemNo || "-"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product?.mainCategory?.name || "-"}
                                    </td>
                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.itemCategory || "-"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product?.food_type || "-"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-700">
                                        ₹{product.vendorPrice?.toFixed(2) || "0.00"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-700">
                                        ₹{product.finalPrice?.toFixed(2) || "0.00"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.gstAmount ? `${product.gstAmount}%` : "0%"}
                                    </td>
                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.description ? `${product.description}` : ""}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.quantity || 0}
                                    </td>



                                    {/* Status */}
                                    <td className="px-3 py-3 text-sm">
                                        <StatusToggle status={activeStatus} onChange={handleToggle} />
                                    </td>

                                    {/* Created At */}
                                    <td className="px-3 py-3 text-xs text-gray-500">
                                        {new Date(product.createdAt).toLocaleDateString("en-IN", {
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                        })}
                                    </td>

                                    {/* Action Buttons */}
                                    <td className="px-3 py-3">
                                        <div className="flex justify-center gap-3">
                                            {/* <button
                                                onClick={() =>
                                                    openModal({ type: "view", data: { state: product } })
                                                }
                                                className="text-blue-600 hover:text-blue-800"
                                                title="View"
                                            >
                                                <FaEye size={18} />
                                            </button> */}
                                            <button
                                                onClick={() =>
                                                    openModal({ type: "edit", data: { state: product } })
                                                }
                                                className="text-primary"
                                                title="Edit"
                                            >
                                                <FaEdit size={18} />
                                            </button>
                                            <button
                                                onClick={() =>
                                                    openModal({ type: "delete", data: { state: product } })
                                                }
                                                className="text-red-500 hover:text-red-700"
                                                title="Delete"
                                            >
                                                <FaTrashAlt size={18} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    }
                />

                {totalPages > 1 && (
                    <Pagination
                        pagination={{
                            currentPage,
                            totalPages,
                            totalItems: totalItems,
                            perPage: limit,
                        }}
                        handlePageChange={setPage}
                        loading={loading}
                    />
                )}
            </div>
            <Modal isOpen={isOpen} onClose={closeModal} size="large">

                {actionType?.type === "add" && (
                    <ProductImport data={actionType?.data?.state} closeModal={closeModal} callback={fetchData} />
                )}
                {actionType?.type === "edit" && (
                    <ProductEdit
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}

                {actionType?.type === "delete" && (
                    <ProductDelete
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
            </Modal>
        </Layout>
    );
};

export default ImportCatgeory;

